import React from "react";

import { Button, Spin } from "antd";

const confirmSoftDeleteWorkerText = () => (
  <div>
    <p>
      This action will schedule a deletion of the user's account. The user will be notified and will
      will have 30 days to cancel the deletion. After 30 days, the user's account will be switched
      to deleted. You will be able to restore the account if needed.
    </p>
    <br />
    <p>This action will be logged.</p>
  </div>
);

const confirmDeleteWorkerText = () => (
  <div>
    <p>
      All of the user's personally identifiable data will be removed from all databases and third
      party tools in 45 days. You will no longer be able to perform actions on the user's account.
    </p>
    <br />
    <p>This action will be logged.</p>
  </div>
);

const constructStripeNegativeBalanceText = (balance) => {
  return (
    <div>
      <p>
        This user has a negative balance of ${(balance?.actualBalance / 100) * -1}. Would you still
        like to delete their account?
      </p>
    </div>
  );
};

const errorFetchingBalanceText = (
  <div>
    Error fetching user’s Stripe balance. Please check manually for a non-zero balance at{" "}
    <a href="https://dashboard.stripe.com/customers" target="_blank">
      https://dashboard.stripe.com/customers
    </a>
  </div>
);

const constructStripeNegativeBalanceButton = (showDeleteButton, onCancel) => (
  <>
    <Button type="primary" onClick={showDeleteButton}>
      Yes
    </Button>
    <Button onClick={onCancel}>Cancel</Button>
  </>
);

const constructIsErrorButton = (showDeleteButton, onCancel) => (
  <>
    <Button type="primary" onClick={showDeleteButton}>
      Continue with Account Deletion
    </Button>
    <Button danger onClick={onCancel}>
      Cancel
    </Button>
  </>
);

const constructConfirmDeletionBtn = (loading, onConfirmDeletion) => {
  return (
    <>
      {loading ? (
        <Spin />
      ) : (
        <Button type="primary" danger onClick={onConfirmDeletion}>
          Delete Account
        </Button>
      )}
    </>
  );
};

export {
  confirmDeleteWorkerText,
  confirmSoftDeleteWorkerText,
  constructStripeNegativeBalanceText,
  errorFetchingBalanceText,
  constructStripeNegativeBalanceButton,
  constructIsErrorButton,
  constructConfirmDeletionBtn,
};
